const STYLE_GUIDE_API_URL = 'https://style-guide-mini-api-998838505944.europe-west6.run.app';

export async function getStyleGuide(version, filename) {
    if (!version || !filename) return [];

    const response = await fetch(STYLE_GUIDE_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "get_versioned_doer_rules",
            version: version,
            filename: filename,
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to load style rules: ${response.status}`);
    }

    return (await response.json()).data;
}

export async function publishStyleGuide(version, filename, target) {
    const response = await fetch(STYLE_GUIDE_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "publish_doer_rules",
            version: version,
            filename: filename.replace(".json", ""),
            target: target,
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to publish style rules: ${response.status}`);
    }
    
    return await response.json();
}

export async function saveStyleGuideRules(version, filename, rulesData) {
    const response = await fetch(STYLE_GUIDE_API_URL, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "save_as_doer_rules",
            version: version,
            filename: filename,
            rules: rulesData.map(d => {
                // Remove rule_index if present, only used by ui
                const { rule_index, ...data } = d;
                return data;
            })
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to save style rules: ${response.status}`);
    }

    return await response.json();
}

export async function editExistingStyleGuideRule(taxonomyFile, styleGuideId, styleGuideRuleIndex, mongoRule, dbname) {
    const response = await fetch(`${STYLE_GUIDE_API_URL}?dbname=${dbname}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "update_single_rule",
            taxonomyFile: taxonomyFile,
            styleGuideId: styleGuideId,
            styleGuideRuleIndex: styleGuideRuleIndex,
            updatedRule: mongoRule
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to update rule: ${response.status}`);
    }

    return;
}

export async function createNewStyleGuideRule(dbname, taxonomyFile, styleGuideId, mongoRule) {
    const response = await fetch(`${STYLE_GUIDE_API_URL}?dbname=${dbname}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "add_single_rule",
            taxonomyFile: taxonomyFile,
            styleGuideId: styleGuideId,
            newRule: mongoRule
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to create rule: ${response.status}`);
    }

    return await response.json();
}

export async function deleteStyleGuideRule(dbname, taxonomyFile, styleGuideId, styleGuideRuleIndex) {
    const response = await fetch(`${STYLE_GUIDE_API_URL}?dbname=${dbname}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            action: "delete_single_rule",
            taxonomyFile: taxonomyFile,
            styleGuideId: styleGuideId,
            styleGuideRuleIndex: styleGuideRuleIndex,
        })
    });

    if (!response.ok) {
        throw new Error(`Failed to delete rule: ${response.status}`);
    }

    return await response.json();
}